import { cn } from "@homeinstead/ui";
import { ApplyToBeACareGiverButton } from "./CareGiverApplyButtonClient";

export { ApplyToBeACareGiverButton };

export const ApplyToBeACareGiverSection = ({
  className,
  buttonClassName,
}: {
  className?: string;
  buttonClassName?: string;
}) => {
  return (
    <div className={cn(`flex px-2 text-sm`, className)}>
      <ApplyToBeACareGiverButton className={buttonClassName}>
        Apply to be a caregiver
      </ApplyToBeACareGiverButton>
    </div>
  );
};
